module.exports = __webpack_public_path__ + "static/media/IMG_0402.25e06626.JPG";